import React, { useEffect, useState } from "react";
import { QuotationService } from "../../../../Services/Manage/QuotationService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  Flex,
  Select,
  DatePicker,
  Row,
  Col,
  Form,
  Button,
  Typography,
} from "antd";
import AddQuotationData from "../AddQuotationData";
import ListEqData from "../ListEqData";
import { ArrowLeftOutlined, UserOutlined } from "@ant-design/icons";
import useMessage from "antd/es/message/useMessage";
import EditQuotationData from "./EditQuotationData";
import dayjs from "dayjs";
import { EnquiryService } from "../../../../Services/Manage/EnquiryService";

const EditViewQuotation = () => {
  const [quteData, setQutoData] = useState([]);
  const location = useLocation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const qu_no = location.state?.qu_no;
  const [data, setData] = useState([]);
  const [message, msgConxt] = useMessage();
  const [eqData, setEqData] = useState([]);
  const [qu_gen, setQu_gen] = useState([]);
  const [Eqslected, seEQSelect] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [quRowData, setQuRowData] = useState([]);
  const [customerForm] = Form.useForm();
  const [followDate, setFollowDate] = useState("");

  const { Option, OptGroup } = Select;

  useEffect(() => {
    if (!qu_no) {
      console.warn("No quotation number provided!");
      navigate("/quotation");
      return;
    }

    console.log("Editing Quotation:", qu_no);
    getQuotationData(qu_no);
  }, [qu_no, navigate]);

  useEffect(() => {
    getCustomerData(quteData?.qu_no);
  }, [quteData]);

  const getCustomerData = async (qu_id) => {
    console.log(qu_id);

    try {
      const request = await EnquiryService.getCustomerDataByQuID(qu_id);
      //   setCustomerData(request.data)
      customerForm.setFieldsValue({
        ...request.data,
        n_follow_up: request.data.n_follow_up
          ? dayjs(request.data.n_follow_up, "DD-MM-YYYY")
          : null,
        //   customerForm
      });
    } catch (error) {
      console.error(error);
    }
  };

  const grouped = data.reduce((acc, item) => {
    if (!acc[item.service_id]) {
      acc[item.service_id] = {
        service_name: item.service_name,
        items: [],
      };
    }
    acc[item.service_id].items.push(item);
    return acc;
  }, {});

  const Title = ({ title }) => (
    <Flex align="center" justify="space-between">
      {title}
    </Flex>
  );

  const renderItem = (eqId, name) => (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <span>{eqId}</span>
      <span>
        <UserOutlined /> {name}
      </span>
    </Flex>
  );

  const getQuotationData = async (id) => {
    try {
      const request = await QuotationService.getAllQuotationById(id);
      setQutoData(request?.data?.quotation);
      setQuRowData(request?.data?.quotation_data);

      handleGetDatabyEqid(request?.data?.quotation?.eq_no);

      form.setFieldsValue({
        enquiry: request?.data?.quotation?.eq_no,
        quotationDate: request?.data?.quotation.date
          ? dayjs(request.data.quotation.date)
          : null,
        n_follow_up: request?.data?.quotation.n_follow_up
          ? dayjs(request.data.quotation.n_follow_up)
          : null,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDatabyEqid = async (id) => {
    try {
      const request = await EnquiryService.getEnquiryDetailsById(id);
      console.log(request);

      if (request.status) {
        setEqData(request.data);
        seEQSelect(true);
      } else {
        console.log(request.message);
      }
      // console.log("Selected eq_id:", value);
      // console.log("Full option object:", option);
    } catch (error) {
      console.error(error);
    }
  };

  console.log(quteData);

  const toggleEdit = () => {
    seEQSelect((prev) => !prev);
  };

  return (
    <>
      {msgConxt}
      <Card
        size="large"
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ArrowLeftOutlined
              style={{ cursor: "pointer", fontSize: "20px" }}
              onClick={() => window.history.back()}
            />
            <Typography.Title level={4} style={{ margin: 0 }}>
              Edit Quotation
            </Typography.Title>
          </div>
        }
      >
        <Form form={form} layout="vertical">
          <Row gutter={[24, 16]}>
            <Col xs={24} sm={8} md={8} lg={8}>
              <Form.Item label="Quotation Date" name="quotationDate">
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  size="large"
                  value={selectedDate ? dayjs(selectedDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const formattedForDB = dayjs(date).format("YYYY-MM-DD");
                      console.log("Send this to DB:", formattedForDB);

                      setSelectedDate(formattedForDB);
                    } else {
                      setSelectedDate(null);
                    }
                  }}
                />
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={8} md={8} lg={8}>
              <Form.Item label="Selected Enquiry" name="enquiry">
                <Select
                  disabled
                  showSearch
                  onClear={() => {
                    seEQSelect(false);
                    setEqData(null);
                    setQu_gen(null);
                  }}
                  style={{ width: "100%" }}
                  placeholder="Select approved enquiry"
                  size="large"
                  // onChange={(value, option) => handleGetDatabyEqid(value, option)}
                  filterOption={(input, option) => {
                    const serviceName =
                      option?.service_name?.toLowerCase() ?? "";
                    const eqId = option?.eq_id?.toLowerCase() ?? "";
                    const name = option?.name?.toLowerCase() ?? "";
                    const search = input.toLowerCase();
                    return (
                      serviceName.includes(search) ||
                      eqId.includes(search) ||
                      name.includes(search)
                    );
                  }}
                >
                  {Object.values(grouped).map((group) => (
                    <OptGroup
                      key={group.service_name}
                      label={<Title title={group.service_name} />}
                    >
                      {group.items.map((item) => (
                        <Option
                          key={item.eq_id}
                          value={item.eq_id}
                          service_name={group.service_name}
                          eq_id={item.eq_id}
                          name={item.name}
                        >
                          {renderItem(item.eq_id, item.name)}
                        </Option>
                      ))}
                    </OptGroup>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}

            <Col xs={24} sm={8} md={8} lg={8}>
              <Form.Item
                layout="vertical"
                name="n_follow_up"
                label="Next Follow-up On"
              >
                <DatePicker
                  size="large"
                  format="DD-MM-YYYY"
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                  value={followDate ? dayjs(followDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const formattedForDB = dayjs(date).format("YYYY-MM-DD");
                      console.log("Send this to DB:", formattedForDB);

                      setFollowDate(formattedForDB);
                    } else {
                      setFollowDate(null);
                    }
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card style={{ marginTop: "10px", maxHeight: "370px" }}>
        <ListEqData data={eqData} quteData={quteData} form={customerForm} />
      </Card>

      <Card style={{ marginTop: "10px" }}>
        <EditQuotationData
          followDate={followDate}
          quteData={quteData}
          initialData={quRowData}
          Eqslected={!Eqslected}
          data={qu_gen}
          selectedDate={selectedDate}
          eqData={eqData}
          customerForm={customerForm}
        />
      </Card>
    </>
  );
};

export default EditViewQuotation;
